<template>
  <div>
    <h1 class="mt-3 text-xs-center">Vehicle KWh Usage</h1>

    <v-layout row wrap px-2>
      <v-flex xs12 sm6 md3 pa-2>
        <v-text-field
          v-model="selectedDate"
          type="date"
          label="Usage Date (UTC)"
          :disabled="apiInProgress || anyRowSaving"
        />
      </v-flex>

      <v-flex xs12 sm6 md3 pa-2>
        <v-select
          class="v-select--fixed-width"
          v-model="selectedAgencyId"
          :items="agencyOptions"
          item-text="text"
          item-value="value"
          label="Agency"
          clearable
          :disabled="apiInProgress || anyRowSaving"
          :menu-props="{ offsetY: true }"
        />
      </v-flex>

      <v-flex xs12 sm10 md5 pa-2>
        <transportation-profile-autocomplete
          v-model="selectedProfile"
          label="Bus Search"
          placeholder="Search vehicle by license plate or driver"
          :disabled="apiInProgress || anyRowSaving"
          clearable
        />
      </v-flex>

      <v-flex xs12 sm2 md1 pa-2 class="text-xs-right">
        <v-btn small fab @click="loadRows" :disabled="apiInProgress || anyRowSaving">
          <v-icon small>fal fa-filter</v-icon>
        </v-btn>
      </v-flex>
    </v-layout>

    <h2 class="text-xs-center mb-3">{{ formattedSelectedDateHeading }}</h2>

    <v-data-table
      :headers="headers"
      :items="buses"
      :loading="apiInProgress"
      :pagination.sync="pagination"
      :total-items="totalBuses"
      :rows-per-page-items="[10, 25, 50, 100]"
      @update:pagination="onPaginationChange"
      class="elevation-1 vehicle-kwh-table"
      must-sort
    >
      <template v-slot:items="{ item }">
        <tr>
          <td class="license-plate-cell">{{ item.licensePlateNumber || '-' }}</td>
          <td class="kwh-input-cell">
            <div class="kwh-input-wrapper">
              <v-text-field
                :ref="'kwhInput-' + item.id"
                v-model="draftByProfileId[String(item.id)]"
                type="number"
                min="0"
                step="0.001"
                hide-details
                placeholder="0.000"
                :disabled="isOnlyInvestor || isSavingRow(item.id)"
                @blur="handleRowBlur(item.id)"
              />
              <div class="kwh-undo-slot">
                <v-btn
                  v-show="!isOnlyInvestor && canUndoRow(item.id)"
                  small
                  flat
                  title="Undo to previous saved value"
                  tabindex="-1"
                  @mousedown.prevent
                  @click="undoRow(item.id)"
                >
                  Undo
                </v-btn>
              </div>
            </div>
          </td>
          <td class="kwh-status-cell">
            <v-tooltip top max-width="360" :disabled="!formatRowStatus(item.id)">
              <template v-slot:activator="{ on }">
                <span class="kwh-status-text" :class="formatRowStatusClass(item.id)" v-on="on">
                  {{ formatRowStatus(item.id) }}
                </span>
              </template>
              <span>{{ formatRowStatus(item.id) }}</span>
            </v-tooltip>
          </td>
          <td class="kwh-actions-cell text-xs-right">
            <v-btn
              v-if="!isOnlyInvestor"
              small
              color="primary"
              flat
              tabindex="-1"
              @mousedown.prevent
              @click="saveRow(item.id)"
              :loading="isSavingRow(item.id)"
              :disabled="apiInProgress || isSavingRow(item.id)"
            >
              Save
            </v-btn>
            <span v-else class="grey--text text--darken-1">Read only</span>
          </td>
        </tr>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import src from './src'

export default src
</script>

<style scoped>
.vehicle-kwh-table {
  width: 100%;
}
.vehicle-kwh-table /deep/ table {
  table-layout: fixed;
}
.license-plate-cell {
  width: 34%;
}
.kwh-input-cell {
  width: 280px;
}
.kwh-input-wrapper {
  display: flex;
  align-items: center;
}
.kwh-input-wrapper /deep/ .v-text-field {
  flex: 1 1 auto;
}
.kwh-undo-slot {
  flex: 0 0 86px;
  text-align: left;
}
.kwh-status-cell {
  width: 260px;
}
.kwh-status-text {
  display: inline-block;
  overflow: hidden;
  text-overflow: ellipsis;
  vertical-align: middle;
  white-space: nowrap;
  width: 240px;
}
.kwh-actions-cell {
  width: 96px;
}
</style>
